import React from "react";

/**
 * Moonstone brand mark.
 *
 * Image-based logo (replaces the previous Inter wordmark). Source asset:
 * /branding/moonstone-logo.png (full lockup) and moonstone-mark.png (icon only).
 *
 * Variants
 * ────────
 *  - "monogram" : just the geometric mark (used in collapsed sidebar)
 *  - "full"     : full lockup (default)
 */
const LOGO_FULL = "/branding/moonstone-logo.png";
const LOGO_MARK = "/branding/moonstone-app.png";

// Heights in pixels per size preset. Tuned for the new Moonstone logo
// (aspect ratio ~4.3:1 for full lockup, ~1.3:1 for monogram).
const HEIGHTS = {
  xs: 20,
  sm: 26,
  md: 32,
  lg: 40,
  xl: 52,
  "2xl": 72,
  "3xl": 96,
};

export default function MoonstoneWordmark({
  size = "md",
  variant = "full",
  // `withDot` is kept for prop-API back-compat with old callers; the image
  // already embeds the brand mark so we just ignore it.
  withDot: _withDot = false,
  className = "",
  ...rest
}) {
  const px = HEIGHTS[size] || HEIGHTS.md;
  const src = variant === "monogram" ? LOGO_MARK : LOGO_FULL;
  return (
    <img
      data-testid="moonstone-wordmark"
      src={src}
      alt="Moonstone"
      style={{ height: px, width: "auto", display: "block" }}
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
